import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  id: "vue-app-order-payment-options",
  class: "gfu-payment-form",
  "data-qa": "legacy-payment-section"
}
const _hoisted_2 = { class: "_mb-3 _mt-6" }
const _hoisted_3 = { class: "gfu-heading gfu-heading--top-divider" }
const _hoisted_4 = ["action"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["name", "value"]
const _hoisted_7 = ["data-qa"]
const _hoisted_8 = {
  key: 0,
  class: "gfu-payment-form__card-icons"
}
const _hoisted_9 = {
  key: 3,
  class: "gfu-field has-error"
}
const _hoisted_10 = {
  class: "gfu-field__error",
  "data-qa": "field-error"
}
const _hoisted_11 = {
  key: 4,
  class: "_mt-6"
}
const _hoisted_12 = { class: "gfu-heading gfu-heading--top-divider" }
const _hoisted_13 = {
  key: 5,
  class: "gfu-box-actions"
}
const _hoisted_14 = { class: "gfu-box-actions__item" }
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  class: "_ml-1",
  "data-qa": "create-order-btn:Back"
}
const _hoisted_17 = {
  class: "_ml-1",
  "data-qa": "create-order-btn:Back"
}
const _hoisted_18 = { class: "gfu-box-actions__item _ml-a" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")
  const _component_checkbox_field = _resolveComponent("checkbox-field")
  const _component_order_espago_form = _resolveComponent("order-espago-form")
  const _component_fake_instant_payment_form = _resolveComponent("fake-instant-payment-form")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.Resources.Checkout.LegacyCheckoutPaymentMethodSectionTitle), 1 /* TEXT */),
      _createTextVNode(" " + _toDisplayString(_ctx.Resources.Checkout.LegacyCheckoutPaymentMethodSectionSubtitle), 1 /* TEXT */)
    ]),
    ($options.isLegacyPaymentMethod)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          ref: "form",
          action: $props.formAction,
          method: "post",
          onSubmit: _cache[4] || (_cache[4] = (...args) => ($options.submit && $options.submit(...args)))
        }, [
          _createElementVNode("input", {
            type: "hidden",
            name: "orderCode",
            value: $props.orderInfo.orderCode
          }, null, 8 /* PROPS */, _hoisted_5),
          _createElementVNode("input", {
            type: "hidden",
            name: $data.antiForgeryTokenKey,
            value: $props.antiforgeryToken
          }, null, 8 /* PROPS */, _hoisted_6),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.paymentToken) = $event)),
            type: "hidden",
            name: "paymentToken"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $data.paymentToken]
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.digitalDeliveryAccepted) = $event)),
            type: "hidden",
            name: "digitalDeliveryAccepted"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $data.digitalDeliveryAccepted]
          ]),
          _renderSlot(_ctx.$slots, "antiForgery"),
          ($data.showPaymentSelection)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($props.availablePaymentMethods, (method) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `payment-${method.code}`,
                  class: _normalizeClass({'has-error': _ctx.errors.has('paymentMethod')}),
                  "data-qa": 'order-payment-option:' + method.code
                }, [
                  _createVNode(_component_checkbox_field, {
                    modelValue: $data.paymentMethod,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.paymentMethod) = $event)),
                    "checked-value": method.code,
                    condensed: true,
                    name: "paymentMethod",
                    type: "radio",
                    "validator-layout": "none"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(method.name) + " ", 1 /* TEXT */),
                      (method.code === $data.paymentMethods.espago)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                            _createVNode(_component_base_image, {
                              src: "/content/images/payments/card-icon-visa-34x22.png",
                              alt: "Visa"
                            }),
                            _createVNode(_component_base_image, {
                              src: "/content/images/payments/card-icon-mastercard-34x22.png",
                              alt: "Mastercard"
                            }),
                            _createVNode(_component_base_image, {
                              src: "/content/images/payments/card-icon-amex-34x22.png",
                              alt: "Amex"
                            }),
                            _createVNode(_component_base_image, {
                              src: "/content/images/payments/card-icon-jcb-34x22.png",
                              alt: "Jcb"
                            }),
                            _createVNode(_component_base_image, {
                              src: "/content/images/payments/card-icon-diners-34x22.png",
                              alt: "Diners"
                            })
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "checked-value"])
                ], 10 /* CLASS, PROPS */, _hoisted_7))
              }), 128 /* KEYED_FRAGMENT */))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.paymentMethod) = $event)),
                type: "hidden",
                name: "paymentMethod"
              }, null, 512 /* NEED_PATCH */)), [
                [_vModelText, $data.paymentMethod]
              ])
        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_4))
      : _createCommentVNode("v-if", true),
    ($props.availablePaymentMethods.some(c => c.code === $data.paymentMethods.espago))
      ? _withDirectives((_openBlock(), _createBlock(_component_order_espago_form, {
          key: 1,
          ref: "espagoForm",
          class: "_mt-6",
          "enable-american-express": true,
          "enable-diners-club": true,
          "enable-discover": false,
          "enable-jcb": true,
          "enable-master-card": true,
          "enable-visa": true,
          "public-key": $props.paymentProviderOptions.publicKey,
          "use-live-api": $props.paymentProviderOptions.useLiveApi,
          onTokenCreated: $options.onEspagoTokenCreated,
          onEspagoSubmit: $options.onEspagoSubmit
        }, null, 8 /* PROPS */, ["public-key", "use-live-api", "onTokenCreated", "onEspagoSubmit"])), [
          [_vShow, $data.paymentMethod === $data.paymentMethods.espago]
        ])
      : _createCommentVNode("v-if", true),
    ($options.isFakePaymentMethod)
      ? (_openBlock(), _createBlock(_component_fake_instant_payment_form, {
          key: 2,
          ref: "fakeForm",
          "order-code": $props.orderInfo.orderCode,
          "checkout-mode": $props.checkoutMode,
          onStartProcessing: $options.onChildStartProcessing,
          onStopProcessing: $options.onChildStopProcessing,
          onError: $options.onChildError
        }, null, 8 /* PROPS */, ["order-code", "checkout-mode", "onStartProcessing", "onStopProcessing", "onError"]))
      : _createCommentVNode("v-if", true),
    (_ctx.errors.has('paymentMethod'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.Resources.Checkout.InvalidPaymentOptionErrorMessage), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    ($options.isLegacyPaymentMethod && $props.requireAcceptDigitalDelivery)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.Resources.Checkout.CheckoutDigitalProductsTermsSectionTitle), 1 /* TEXT */),
          _createVNode(_component_checkbox_field, {
            modelValue: $data.digitalDeliveryAccepted,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.digitalDeliveryAccepted) = $event)),
            condensed: true,
            "display-name": "Digital delivery agreement",
            name: "digitalDeliveryAccepted",
            "data-qa": "digital-delivery-agreement"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.Checkout.CheckboxDigitalDeliveryAgreementMessage), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"])
        ]))
      : _createCommentVNode("v-if", true),
    ($options.isLegacyPaymentMethod || $options.isFakePaymentMethod)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            (!$props.orderInfo.orderState)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "gfu-link gfu-link--accent",
                  href: $props.backAction
                }, [
                  _createVNode(_component_base_icon, {
                    name: "chevron-left",
                    class: "_fl _lhb"
                  }),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.Resources.Checkout.CheckoutGoBackLink), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_15))
              : ($props.orderInfo.orderCode)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    class: "gfu-link gfu-link--accent",
                    href: "",
                    onClick: _cache[6] || (_cache[6] = _withModifiers((...args) => ($options.defaultBackAction && $options.defaultBackAction(...args)), ["prevent"]))
                  }, [
                    _createVNode(_component_base_icon, {
                      name: "chevron-left",
                      class: "_fl _lhb"
                    }),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.Resources.Checkout.CheckoutGoBackLink), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_tooltip, { text: $options.validationMessage }, {
              default: _withCtx(() => [
                _createVNode(_component_base_button, {
                  href: "",
                  enabled: $options.isValid,
                  theme: "accent",
                  class: "gfu-btn--block",
                  onClick: _withModifiers($options.submit, ["prevent"]),
                  "data-qa": "create-order-btn:Submit"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Resources.Checkout.CheckoutSubmitOrderButton), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["enabled", "onClick"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["text"])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
  ]))
}